import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../../features/sidebar/Sidebar';
import { NoConnection } from '../noConnection/noConnection';
import useOnlineStatus from '../../hooks/useOnlineStatus';

const MainPage: FC = () => {
  const isOffline = useOnlineStatus();

  return (
    <div
      style={{
        display: 'flex',
        height: '100vh',
      }}
    >
      <Sidebar />

      <main
        style={{
          // Critical: Overrides default 'min-width: auto'. Allows container to shrink below content size, forcing wide children (like tables) to scroll internally.
          minWidth: 0,
          flex: 1,
        }}
      >
        {isOffline ? <NoConnection /> : <Outlet />}
      </main>
    </div>
  );
};

export default MainPage;
